import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge, twJoin } from 'tailwind-merge';

/**
 * @deprecated 추후 new__cn 으로 변경 예정
 */
export const cn = (...inputs: ClassValue[]) => twJoin(clsx(inputs));

export const joinCn = (...inputs: ClassValue[]) => twJoin(clsx(inputs));

export const customTwMerge = extendTailwindMerge({
  extend: {
    theme: {
      color: [
        'status-notStarted',
        'status-notStartedEnd',
        'status-rejected',
        'status-rejectedEnd',
        'status-inProgress',
        'status-inProgressEnd',
        'status-submitted',
        'status-submittedEnd',
        'status-inReview',
        'status-inReviewEnd',
        'status-completed',
        'status-completedEnd',
        'status-failed',
        'status-failedEnd',
        'status-aiAnno',
        'status-aiAnnoEnd',
        'status-disabled',
        'status-disabledEnd',
      ],

      spacing: [
        'scale/1',
        'scale/2',
        'scale/4',
        'scale/8',
        'scale/12',
        'scale/16',
        'scale/20',
        'scale/24',
        'scale/32',
        'scale/40',
        'scale/48',
        'scale/56',
        'scale/64',
        'scale/72',
        'scale/80',
        'scale/100',
      ],

      text: [
        'body-sm',
        'body-md',
        'body-lg',
        'body-xl',
        'headline-sm',
        'headline-md',
        'headline-lg',
        'headline-xl',
        'display-sm',
        'display-md',
        'display-lg',
      ],
    },
  },
});

export const new__cn = (...inputs: ClassValue[]) => customTwMerge(clsx(inputs));
